import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  BrandIconElectronicPrescription,
  BrandIconEuro,
  BrandIconPrescriptionBonus,
} from '@redteclab/brand-icons'

import { BrandIcon, Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../../global-config'
import { urlResolverScanEprescription } from '../../../../../url-handling'

export const ErxBonusLandingPageHowToV1: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <div className="container flex flex-col justify-center gap-6 px-4 pb-8 pt-6 tablet:py-12">
      <div className="bg-light-primary-low px-5 text-center text-2xl font-medium tablet:px-0 tablet:text-3xl">
        <FormattedMessage id="deErx.bonus.howTo.title" />
      </div>

      <div className="flex flex-col gap-6 text-m tablet:flex-row tablet:text-center">
        <div className="flex flex-1 gap-4 tablet:flex-col tablet:items-center tablet:gap-2.5">
          <BrandIcon
            className="size-12 shrink-0 grow-0 tablet:size-20"
            color="secondary"
            icon={BrandIconElectronicPrescription}
          />
          <div className="flex flex-col items-start gap-1 tablet:items-center tablet:gap-2.5">
            <span className="font-medium">
              <FormattedMessage id="deErx.bonus.howTo.redeem.title" />
            </span>
            <span>
              <FormattedMessage id="deErx.bonus.howTo.redeem.description" />
            </span>
          </div>
        </div>

        <div className="flex flex-1 gap-4 tablet:flex-col tablet:items-center tablet:gap-2.5">
          <BrandIcon
            className="size-12 shrink-0 grow-0 tablet:size-20"
            color="secondary"
            icon={BrandIconEuro}
          />
          <div className="flex flex-col items-start gap-1 tablet:items-center tablet:gap-2.5">
            <span className="font-medium">
              <FormattedMessage id="deErx.bonus.howTo.amount.title" />
            </span>
            <span>
              <FormattedMessage id="deErx.bonus.howTo.amount.description" />
            </span>
          </div>
        </div>

        <div className="flex flex-1 gap-4 tablet:flex-col tablet:items-center tablet:gap-2.5">
          <BrandIcon
            className="size-12 shrink-0 grow-0 tablet:size-20"
            color="secondary"
            icon={BrandIconPrescriptionBonus}
          />
          <div className="flex flex-col items-start gap-1 tablet:items-center tablet:gap-2.5">
            <span className="font-medium">
              <FormattedMessage id="deErx.bonus.howTo.receive.title" />
            </span>
            <span>
              <FormattedMessage id="deErx.bonus.howTo.receive.description" />
            </span>
          </div>
        </div>

        <Button<'a'>
          className="w-full tablet:hidden"
          href={urlResolverScanEprescription(globalConfig)}
          size="medium"
          slots={{ root: 'a' }}
        >
          <FormattedMessage id="deErx.bonus.howTo.btn" />
        </Button>
      </div>
    </div>
  )
}
